module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-10.9f4b5171.png";